import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNetSuiteProductionRfq } from '../config/netsuite';

const useFetchNetsuiteDropdown = () => {
  const [workscopes, setWorkscopes] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [taxCodes, setTaxCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [workscopesRes, accountsRes, uomsRes, taxCodesRes] = await Promise.all([
          axios.get(`/api/NetSuite/workscopes?useProduction=${useNetSuiteProductionRfq}`),
          axios.get(`/api/NetSuite/items?useProduction=${useNetSuiteProductionRfq}`),
          axios.get(`/api/NetSuite/uom?useProduction=${useNetSuiteProductionRfq}`),
          axios.get(`/api/NetSuite/taxcodes?useProduction=${useNetSuiteProductionRfq}`),
        ]);

        setWorkscopes((workscopesRes.data?.items ?? []).sort((a, b) => a?.name?.localeCompare(b?.name)));
        setAccounts((accountsRes.data?.items ?? []).sort((a, b) => a?.fullname?.localeCompare(b?.fullname)));
        setUoms((uomsRes.data?.items ?? []).sort((a, b) => a?.name?.localeCompare(b?.name)));
        setTaxCodes(
          (taxCodesRes.data?.items ?? []).map((item) => ({
            value: item.custrecord_bpc_tax_code_internal_id,
            text: item.custrecord_bpc_tax_name,
            rate: item.custrecord_bpc_rate / 100,
          }))
        );
      } catch (err) {
        console.error('Error fetching dropdown data:', err);
        setError(err.message || 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { workscopes, accounts, uoms, taxCodes, loading, error };
};

export default useFetchNetsuiteDropdown;
